const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8.039,
    xmlns: "http://www.w3.org/2000/svg",
    height: 4.77,
    id: "screenshot-0bd5c767-32dc-80ef-8007-61804de59ff9",
    viewBox: "134 5417 8.039 4.77",
    style: {
      WebkitPrintColorAdjust: ":exact"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-0bd5c767-32dc-80ef-8007-61804de59ff9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-0bd5c767-32dc-80ef-8007-61804de59ff9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.01953125,5421.76953125L134,5417L142.03912353515625,5417L138.01953125,5421.76953125",
    style: {
      fill: "#ffffff",
      fillOpacity: 0.6
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-786606cb-d337-8037-8007-627bbcf90f71-0bd5c767-32dc-80ef-8007-61804de59ff9",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.01953125,5421.76953125L134,5417L142.03912353515625,5417L138.01953125,5421.76953125",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 0,
      stroke: "#000000",
      strokeOpacity: 1
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/DownArrow.03b9777ad64f54f1dad3a13a434e3d9f.svg";
export { ForwardRef as ReactComponent };